export default {
  'Downloadable Files (Optional)': {
    en: 'Downloadable Files (Optional)',
    ja: 'ダウンロード可能なファイル（オプション）',
    et: 'Allalaaditavad failid (Valikuline)',
    lt: 'Parsisiųsti failai (neprivaloma pildyti)',
    ph: 'Downloadable Files (Optional)',
    ch: 'Downloadable Files (Optional)',
  },
  fileLimit: {
    en: 'No files bigger than {{limit}} MB (max {{countLimit}} files)',
    ja: 'ファイルのサイズは {{limit}} MB (max {{countLimit}} files) まで',
    et: 'Faili max suurus {{limit}} MB (maksimaalselt {{countLimit}} faili)',
    lt: 'Skirta ne didesniems nei {{limit}} MB failams (didžiausias failų kiekis {{countLimit}})',
    ph: 'No files bigger than {{limit}} MB (max {{countLimit}} files)',
    ch: 'No files bigger than {{limit}} MB (max {{countLimit}} files)',
  },
  '(e.g. 3D model/printing files, laser cutting files, Roblox files, etc.)': {
    en: '(e.g. 3D model/printing files, laser cutting files, Roblox files, etc.)',
    ja: '（例：３Dモデル、レーサーカット用のファイル、Robloxファイルなど）',
    et: '(nt. 3D mudelid, laserlõikuri failid, Robloxi failid jms)',
    lt: '(pavyzdžiui, 3D failai, lazerinei pjaustyklei paruošti failai ir t.t.)',
    ph: '(e.g. 3D model/printing files, laser cutting files, Roblox files, etc.)',
    ch: '(e.g. 3D model/printing files, laser cutting files, Roblox files, etc.)',
  },
  fileTooLarge: {
    en: 'File is too large. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
    ja: 'ファイルは大きすぎます。ファイルのサイズは {{size}} バイト、最大サイズは {{maxSize}} バイト.',
    et: 'Fail on liiga suur - {{size}} baiti. Maksimum lubatud on {{maxSize}} baiti. ',
    lt: 'Failas per didelis, jo dydis baitais yra {{size}}. Didžiausias priimamas dydis baitais yra {{maxSize}}',
    ph: 'File is too large. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
    ch: 'File is too large. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
  },
  fileRotateTooLarge: {
    en: 'File is too large after rotation. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
    ja: '回転後のファイルは大きすぎます。ファイルのサイズは {{size}} バイト、最大サイズは {{maxSize}} バイト.',
    et: 'Fail on liiga suur - {{size}} baiti. Maksimum lubatud on {{maxSize}} baiti. ',
    lt: 'Failas per didelis, jo dydis baitais yra {{size}}. Didžiausias priimamas dydis baitais yra {{maxSize}}',
    ph: 'File is too large after rotation. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
    ch: 'File is too large after rotation. File size is {{size}} bytes. Max File size {{maxSize}} bytes',
  },
  bytes: {
    en: 'bytes',
    ja: 'バイト',
    et: 'baiti',
    lt: 'baitai',
    ph: 'bytes',
    ch: 'bytes',
  },
  Bytes: {
    en: 'Bytes',
    ja: 'バイト',
    et: 'Baiti',
    lt: 'Baitai',
    ph: 'Bytes',
    ch: 'Bytes',
  },
  'Add File': {
    en: 'Add File',
    ja: 'ファイル追加',
    et: 'Lisa fail',
    lt: 'Pridėti failą',
    ph: 'Add File',
    ch: 'Add File',
  },
  'Please give your project a title': {
    en: 'Please give your project a title',
    ja: 'プロジェクト名をつけてください',
    et: 'Projekti nimi',
    lt: 'Pavadink savo projektą',
    ph: 'Please give your project a title',
    ch: 'Please give your project a title',
  },
  'Please select a thumbnail for your project': {
    en: 'Please select a thumbnail for your project',
    ja: 'プロジェクトのサムネイルを選択してください',
    et: 'Valige oma projekti jaoks pisipilt',
    lt: 'Please select a thumbnail for your project',
    ph: 'Please select a thumbnail for your project',
    ch: 'Please select a thumbnail for your project',
  },
  'Please upload a video or photo of your project': {
    en: 'Please upload a video or photo of your project',
    ja: 'プロジェクトのビデオまたは画像をアップロードしてください',
    et: 'Laadige üles oma projektist video või foto',
    lt: 'Please upload a video or photo of your project',
    ph: 'Please upload a video or photo of your project',
    ch: 'Please upload a video or photo of your project',
  },
  'Project Title (Required)': {
    en: 'Project Title (Required)',
    ja: 'プロジェクト名（必須）',
    et: 'Projekti nimi (Kohustuslik)',
    lt: 'Projekto pavadinimas (būtinas)',
    ph: 'Project Title (Required)',
    ch: 'Project Title (Required)',
  },
  'Project Title': {
    en: 'Project Title',
    ja: 'プロジェクト名',
    et: 'Projekti nimi',
    lt: 'Projekto pavadinimas',
    ph: 'Project Title',
    ch: 'Project Title',
  },
  'What Inspired You? (Optional)': {
    en: 'What Inspired You? (Optional)',
    ja: 'どうしてこのプロジェクトを作りましたか？（オプション）',
    et: 'Mis sind inspireeris? (Valikuline)',
    lt: 'Kas tave įkvėpė? (neprivaloma atsakyti)',
    ph: 'What Inspired You? (Optional)',
    ch: 'What Inspired You? (Optional)',
  },
  'How Did You Make This? (Optional! You can write this in your project update later)':
    {
      en: 'How Did You Make This? (Optional! You can write this in your project update later)',
      ja: '作り方（オプション、または後で追加可能）',
      et: 'Kuidas projekt valmis? (Valikuline. Võid lisada kirjelduse hiljem)',
      lt: 'Kaip viską padarei? (neprivaloma - galėsi parašyti projekto aprašyme vėliau)',
      ph: 'How Did You Make This? (Optional! You can write this in your project update later)',
      ch: 'How Did You Make This? (Optional! You can write this in your project update later)',
    },
  'What updates did you make to this project?': {
    en: 'What updates did you make to this project?',
    ja: '新しく追加した点',
    et: 'Milliseid täiendusi tegid projektile?',
    lt: 'Kaip keitei šitą projektą?',
    ph: 'What updates did you make to this project?',
    ch: 'What updates did you make to this project?',
  },
  Back: {
    en: 'Back',
    ja: '前へ',
    et: 'Tagasi',
    lt: 'Atgal',
    ph: 'Back',
    ch: 'Back',
  },
  Delete: {
    en: 'Delete',
    ja: '削除',
    et: 'Kustuta',
    lt: 'Ištrinti',
    ph: 'Delete',
    ch: 'Delete',
  },
  Next: {
    en: 'Next',
    ja: '次へ',
    et: 'Järgmine',
    lt: 'Kitas',
    ph: 'Next',
    ch: 'Next',
  },
  Post: {
    en: 'Post',
    ja: 'アップロード',
    et: 'Postita',
    lt: 'Viešinti',
    ph: 'Post',
    ch: 'Post',
  },
  'Project Categories': {
    en: 'Project Categories',
    ja: 'プロジェクトのカテゴリ',
    et: 'Projekti kategooriad',
    lt: 'Projektų kategorijos',
    ph: 'Project Categories',
    ch: 'Project Categories',
  },
  'To add a new category, type in your category and press Enter.': {
    en: 'To add a new category, type in your category and press Enter.',
    ja: '新しいカテゴリを追加するには、カテゴリ名を入力してEnterを押す',
    et: 'Uue kategooria lisamiseks, toksi sisse kategooria ja vajuta Enter.',
    lt: 'Kad pridėtum naują kategoriją, parašyk jos pavadinimą ir spausk Enter',
    ph: 'To add a new category, type in your category and press Enter.',
    ch: 'To add a new category, type in your category and press Enter.',
  },
  'Is this a work-in-progress or completed project?': {
    en: 'Is this a work-in-progress or completed project?',
    ja: '製作中、それとも完成したプロジェクトですか？',
    et: 'Kas see on poolik või valmis projekt?',
    lt: 'Ar tai - baigtas projektas, ar dar vykdomas? ',
    ph: 'Is this a work-in-progress or completed project?',
    ch: 'Is this a work-in-progress or completed project?',
  },
  'Is this a work-in-progress or completed project update?': {
    en: 'Is this a work-in-progress or completed project update?',
    ja: '製作中、それとも完成したプロジェクトの更新ですか？',
    et: 'Kas see on poolik või valmis Projektiuuendus?',
    lt: 'Ar tai - projekto atnaujinimas, ar jau baigtas projektas? ',
    ph: 'Is this a work-in-progress or completed project update?',
    ch: 'Is this a work-in-progress or completed project update?',
  },
  Completed: {
    en: 'Completed',
    ja: '完成',
    et: 'Valmis projekt',
    lt: 'Baigta',
    ph: 'Completed',
    ch: 'Completed',
  },
  'Work-In-Progress': {
    en: 'Work-In-Progress',
    ja: '製作中',
    et: 'Pooleliolev projekt',
    lt: 'Vykdoma',
    ph: 'Work-In-Progress',
    ch: 'Work-In-Progress',
  },
  'Project Videos': {
    en: 'Project Videos',
    ja: 'プロジェクトビデオ',
    et: 'Projekti videod',
    lt: 'Project Videos',
    ph: 'Project Videos',
    ch: 'Project Videos',
  },
  'Project Photos': {
    en: 'Project Photos',
    ja: 'プロジェクト画像',
    et: 'Projekti pildid',
    lt: 'Projekto nuotraukos',
    ph: 'Project Photos',
    ch: 'Project Photos',
  },
  videoLimit: {
    en: 'No videos bigger than {{limit}} MB (max {{countLimit}} videos)',
    ja: 'ビデオの最大サイズは {{limit}} MB (最多 {{countLimit}} ビデオ)',
    et: 'Videod max suurus {{limit}} MB (maksimaalselt {{countLimit}} videot)',
    lt: 'No videos bigger than {{limit}} MB (max {{countLimit}} videos)',
    ph: 'No videos bigger than {{limit}} MB (max {{countLimit}} videos)',
    ch: 'No videos bigger than {{limit}} MB (max {{countLimit}} videos)',
  },
  imageLimit: {
    en: 'No images bigger than {{limit}} MB (max {{countLimit}} images)',
    ja: '画像の最大サイズは {{limit}} MB (最多 {{countLimit}} 画像)',
    et: 'Pildi max suurus {{limit}} MB (maksimaalselt {{countLimit}} pilti)',
    lt: 'Negalima įdėti nuotraukų, didesnių nei {{limit}} MB (daugiausiai {{countLimit}} nuotraukų)',
    ph: 'No images bigger than {{limit}} MB (max {{countLimit}} images)',
    ch: 'No images bigger than {{limit}} MB (max {{countLimit}} images)',
  },
  deleteVideo: {
    en: 'Discard video? This will remove the video from your post.',
    ja: '動画を破棄しますか？これにより、投稿から動画が削除されます。',
    et: 'Kas loobuda videost? See eemaldab video teie postitusest.',
    lt: 'Discard video? This will remove the video from your post.',
    ph: 'Discard video? This will remove the video from your post.',
    ch: 'Discard video? This will remove the video from your post.',
  },
  Uploading: {
    en: 'Uploading',
    ja: 'アップロード中',
    et: 'Üleslaadimine',
    lt: 'Uploading',
    ph: 'Uploading',
    ch: 'Uploading',
  },
  'Add Video': {
    en: 'Add Video',
    ja: 'ビデオを追加',
    et: 'Lisa video',
    lt: 'Add Video',
    ph: 'Add Video',
    ch: 'Add Video',
  },
  'Uploading Video': {
    en: 'Uploading Video',
    ja: '動画のアップロード',
    et: 'Video üleslaadimine',
    lt: 'Uploading Video',
    ph: 'Uploading Video',
    ch: 'Uploading Video',
  },
  'Add Image': {
    en: 'Add Image',
    ja: '画像追加',
    et: 'lisa pilt',
    lt: 'Pridėti nuotrauką',
    ph: 'Add Image',
    ch: 'Add Image',
  },
  'Project Thumbnail (Required)': {
    en: 'Project Thumbnail (Required)',
    ja: 'プロジェクトのサムネイル (必須)',
    et: 'Projekti pisipilt (Kohustuslik)',
    lt: 'Project Thumbnail (Required)',
    ph: 'Project Thumbnail (Required)',
    ch: 'Project Thumbnail (Required)',
  },
  selectThumbnail: {
    en: 'Select from the images below for your project thumbnail',
    ja: 'プロジェクトのサムネイル用に下の画像から選択してください',
    et: 'Valige oma projekti pisipildi jaoks allolevate piltide hulgast',
    lt: 'Select from the images below for your project thumbnail',
    ph: 'Select from the images below for your project thumbnail',
    ch: 'Select from the images below for your project thumbnail',
  },
  'Does your project deserve a badge?': {
    en: 'Does your project deserve a badge?',
    ja: 'バッジを獲得することができるプロジェクトですか？',
    et: 'Kas su projekt väärib märke?',
    lt: 'Ar tavo projektas nusipelnė ženkliuko?',
    ph: 'Does your project deserve a badge?',
    ch: 'Does your project deserve a badge?',
  },
  'Select the badges below!': {
    en: 'Select the badges below!',
    ja: 'バッジを選択',
    et: 'Valige alt märgid!',
    lt: 'Pasirink ženkliukus žemiau!',
    ph: 'Select the badges below!',
    ch: 'Select the badges below!',
  },
  badgeSelected: {
    en: '({{count}}) selected',
    ja: '選択した数 ({{count}}) ',
    et: '({{count}}) valitud',
    lt: '({{count}}) pasirinkta',
    ph: '({{count}}) selected',
    ch: '({{count}}) selected',
  },
  'Search Badges': {
    en: 'Search Badges',
    ja: 'バッジを検索',
    et: 'Otsi märgid',
    lt: 'Ieškok ženkliukų',
    ph: 'Search Badges',
    ch: 'Search Badges',
  },
  'All Categories': {
    en: 'All Categories',
    ja: 'すべてのカテゴリ',
    et: 'Kõik kategooriad',
    lt: 'Visos kategorijos',
    ph: 'All Categories',
    ch: 'All Categories',
  },
  Add: {
    en: 'Add',
    ja: '追加',
    et: 'Lisa',
    lt: 'Pridėti',
    ph: 'Add',
    ch: 'Add',
  },
  Cancel: {
    en: 'Cancel',
    ja: 'キャンセル',
    et: 'Tühista',
    lt: 'Atšaukti',
    ph: 'Cancel',
    ch: 'Cancel',
  },
  'Comment Edited!': {
    en: 'Comment Edited!',
    ja: 'コメントを変更しました',
    et: 'Kommentaar muudetud!',
    lt: 'Komentaras pakeistas!',
    ph: 'Comment Edited!',
    ch: 'Comment Edited!',
  },
  'Are you sure you want to delete this comment?': {
    en: 'Are you sure you want to delete this comment?',
    ja: 'このコメントを削除しますか？',
    et: 'Oled sa kindel, et tahad kommentaari kustutada?',
    lt: 'Ar tikrai nori ištrinti šį komentarą?',
    ph: 'Are you sure you want to delete this comment?',
    ch: 'Are you sure you want to delete this comment?',
  },
  'Comment Deleted!': {
    en: 'Comment Deleted!',
    ja: 'コメントを削除しました',
    et: 'Kommentaar kustutatud.',
    lt: 'Komentaras ištrintas!',
    ph: 'Comment Deleted!',
    ch: 'Comment Deleted!',
  },
  'Empty comment is not allowed': {
    en: 'Empty comment is not allowed',
    ja: 'コメントを空白にできません',
    et: 'Tühi väli pole lubatud',
    lt: 'Tuščias komentaras neleidžiamas',
    ph: 'Empty comment is not allowed',
    ch: 'Empty comment is not allowed',
  },
  'Comment Replied!': {
    en: 'Comment Replied!',
    ja: 'コメントを返事しました',
    et: 'Kommentaarile vastatud.',
    lt: 'Komentaras atsakytas!',
    ph: 'Comment Replied!',
    ch: 'Comment Replied!',
  },
  'Do you want to flag this comment for review?': {
    en: 'Do you want to flag this comment for review?',
    ja: 'このコメントを報告しますか？',
    et: 'Kas sa tahad, et seda kommentaari modereeritakse?',
    lt: 'Ar nori mums pranešti apie šį komentarą?',
    ph: 'Do you want to flag this comment for review?',
    ch: 'Do you want to flag this comment for review?',
  },
  'This comment is already flagged': {
    en: 'This comment is already flagged',
    ja: 'このコメントはすでに報告済みです',
    et: 'See kommentaar on juba märgitud modereerimiseks.',
    lt: 'Apie šį komentarą mums jau pranešta',
    ph: 'This comment is already flagged',
    ch: 'This comment is already flagged',
  },
  'Thanks! This comment has been flagged for review': {
    en: 'Thanks! This comment has been flagged for review',
    ja: 'このコメントを報告しました。ありがとうございました。',
    et: 'Aitäh! Märkisime, et kommentaar vajab modereerimist.',
    lt: 'Ačiū! Komentaras pažymėtas mūsų peržiūrai',
    ph: 'Thanks! This comment has been flagged for review',
    ch: 'Thanks! This comment has been flagged for review',
  },
  'Save Changes': {
    en: 'Save Changes',
    ja: '変更を保存',
    et: 'Salvesta muudatused',
    lt: 'Išsaugoti pokyčius',
    ph: 'Save Changes',
    ch: 'Save Changes',
  },
  like_zero: {
    en: '{{count}} like',
    ja: '{{count}} いいね',
    et: '{{count}} meeldib',
    lt: '{{count}} patinka',
    ph: '{{count}} like',
    ch: '{{count}} like',
  },
  like_one: {
    en: '{{count}} like',
    ja: '{{count}} いいね',
    et: '{{count}} meeldib',
    lt: '{{count}} patinka',
    ph: '{{count}} like',
    ch: '{{count}} like',
  },
  like_other: {
    en: '{{count}} likes',
    ja: '{{count}} いいね',
    et: '{{count}} meeldib',
    lt: '{{count}} patiktukų',
    ph: '{{count}} likes',
    ch: '{{count}} likes',
  },
  reply: {
    en: 'reply',
    ja: '返事',
    et: 'vasta',
    lt: 'atsakyti',
    ph: 'reply',
    ch: 'reply',
  },
  flag: {
    en: 'flag',
    ja: 'フラグ',
    et: 'märgi',
    lt: 'pažymėti',
    ph: 'flag',
    ch: 'flag',
  },
  edit: {
    en: 'edit',
    ja: '変更',
    et: 'muuda',
    lt: 'keisti',
    ph: 'edit',
    ch: 'edit',
  },
  delete: {
    en: 'delete',
    ja: '削除',
    et: 'kustuta',
    lt: 'ištrinti',
    ph: 'delete',
    ch: 'delete',
  },
  'Add Reply': {
    en: 'Add Reply',
    ja: '返事を追加',
    et: 'Lisa vastus',
    lt: 'Pridėti komentarą',
    ph: 'Add Reply',
    ch: 'Add Reply',
  },
  'No comments yet. Be the first!': {
    en: 'No comments yet. Be the first!',
    ja: 'コメントがまだありません。最初のコメントを書きましょう！',
    et: '0 kommentaari. Ole esimene!',
    lt: 'Dar nėra komentarų. Pakomentuok!',
    ph: 'No comments yet. Be the first!',
    ch: 'No comments yet. Be the first!',
  },
  Comments: {
    en: 'Comments',
    ja: 'コメント',
    et: 'Kommentaarid',
    lt: 'Komentarai',
    ph: 'Comments',
    ch: 'Comments',
  },
  'Show More': {
    en: 'Show More',
    ja: 'さらに表示',
    et: 'Näita veel',
    lt: 'Rodyti daugiau',
    ph: 'Show More',
    ch: 'Show More',
  },
  'Add comment': {
    en: 'Add comment',
    ja: 'コメントを追加',
    et: 'Lisa kommentaar',
    lt: 'Pridėti komentarą',
    ph: 'Add comment',
    ch: 'Add comment',
  },
  submitted_zero: {
    en: 'Submitted {{count}} badge',
    ja: 'バッジの追加数 {{count}}',
    et: 'Lisatud {{count}} märk',
    lt: 'Pridėta {{count}} ženkliukų',
    ph: 'Submitted {{count}} badge',
    ch: 'Submitted {{count}} badge',
  },
  submitted_one: {
    en: 'Submitted {{count}} badge',
    ja: 'バッジの追加数 {{count}}',
    et: 'Lisatud {{count}} märk',
    lt: 'Pridėtas {{count}} ženkliukas',
    ph: 'Submitted {{count}} badge',
    ch: 'Submitted {{count}} badge',
  },
  submitted_other: {
    en: 'Submitted {{count}} badges',
    ja: 'バッジの追加数 {{count}}',
    et: 'Lisatud {{count}} märki',
    lt: 'Pridėta {{count}} ženkliukų',
    ph: 'Submitted {{count}} badges',
    ch: 'Submitted {{count}} badges',
  },
  wins_zero: {
    en: 'Win {{count}} badge',
    ja: 'バッジの獲得数 {{count}}',
    et: 'Võidetud {{count}} märki',
    lt: 'Užsitarnauta {{count}} ženkliukų',
    ph: 'Win {{count}} badge',
    ch: 'Win {{count}} badge',
  },
  wins_one: {
    en: 'Win {{count}} badge',
    ja: 'バッジの獲得数 {{count}}',
    et: 'Võidetud {{count}} märk',
    lt: 'Užsitarnautas {{count}} ženkliukas',
    ph: 'Win {{count}} badge',
    ch: 'Win {{count}} badge',
  },
  wins_other: {
    en: 'Win {{count}} badges',
    ja: 'バッジの獲得数 {{count}}',
    et: 'Võidetud {{count}} märki',
    lt: 'Užsitarnauta {{count}} ženkliukų',
    ph: 'Win {{count}} badges',
    ch: 'Win {{count}} badges',
  },
  badge: {
    en: 'badge',
    ja: 'バッジ',
    et: 'märk',
    lt: 'ženkliukas',
    ph: 'badge',
    ch: 'badge',
  },
  badges: {
    en: 'badges',
    ja: 'バッジ',
    et: 'märki',
    lt: 'ženkliukai',
    ph: 'badges',
    ch: 'badges',
  },
  Like: {
    en: 'Like',
    ja: 'いいね',
    et: 'Meeldib',
    lt: 'Patinka',
    ph: 'Like',
    ch: 'Like',
  },
  'DELETE! Are you absolutely certain that you want to DELETE this project?': {
    en: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    ja: 'このプロジェクトを削除します。本当にいいですか？',
    et: 'KUSTUTA. Kas oled kindel, et soovid projekti KUSTUTADA?',
    lt: 'IŠTRINTI! Ar tikrai nori ištrinti šį projektą?',
    ph: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
    ch: 'DELETE! Are you absolutely certain that you want to DELETE this project?',
  },
  'Oops! Are you sure you want to delete this project update?': {
    en: 'Oops! Are you sure you want to delete this project update?',
    ja: 'このプロジェクトアップデートを本当に削除しますか？',
    et: 'Oi! Kas sa oled kindel, et tahad selle projekti uuenduse kustutada?',
    lt: 'Ei, ar tikrai nori ištrinti šį projekto atnaujinimą?',
    ph: 'Oops! Are you sure you want to delete this project update?',
    ch: 'Oops! Are you sure you want to delete this project update?',
  },
  'Project Deleted!': {
    en: 'Project Deleted!',
    ja: 'プロジェクト削除完了',
    et: 'Projekt kustutatud!',
    lt: 'Projektas ištrintas',
    ph: 'Project Deleted!',
    ch: 'Project Deleted!',
  },
  'Project Update Deleted!': {
    en: 'Project Update Deleted!',
    ja: 'プロジェクトアップデートを削除しました',
    et: 'Projektiuuendus kustutatud!',
    lt: 'Projekto atnaujinimas ištrintas',
    ph: 'Project Update Deleted!',
    ch: 'Project Update Deleted!',
  },
  Edit: {
    en: 'Edit',
    ja: '変更',
    et: 'Muuda',
    lt: 'Keisti',
    ph: 'Edit',
    ch: 'Edit',
  },
  'Delete project': {
    en: 'Delete project',
    ja: 'プロジェクトを削除',
    et: 'Kustuta projekt',
    lt: 'Ištrinti projektą',
    ph: 'Delete project',
    ch: 'Delete project',
  },
  'Delete project update': {
    en: 'Delete project update',
    ja: 'プロジェクトアップデートを削除',
    et: 'Kustuta Projektiuuendus',
    lt: 'Ištrinti projekto atnaujinimą',
    ph: 'Delete project update',
    ch: 'Delete project update',
  },
  'Project Files': {
    en: 'Project Files',
    ja: 'プロジェクトのファイル',
    et: 'Projekti failid',
    lt: 'Projekto failai',
    ph: 'Project Files',
    ch: 'Project Files',
  },
  'Comment added!': {
    en: 'Comment added!',
    ja: 'コメントを追加しました。',
    et: 'Kommentaar lisatud!',
    lt: 'Komentaras pridėtas',
    ph: 'Comment added!',
    ch: 'Comment added!',
  },
  Projects: {
    en: 'Projects',
    ja: 'プロジェクト',
    et: 'Projektid',
    lt: 'Projektai',
    ph: 'Projects',
    ch: 'Projects',
  },
  projectDescVivita: {
    en: 'Check out the cool projects by VIVINAUTS in the VIVIBOOM universe!',
    ja: 'VIVIBOOM内の他のVIVINAUTのプロジェクトを見てみましょう！',
    et: 'Vaata, milliseid ägedaid projekte teised vivinaudid on teinud.',
    lt: 'Atrask kitų VIVINAUTŲ projektus! ',
    ph: 'Check out the cool projects by VIVINAUTS in the VIVIBOOM universe!',
    ch: 'Check out the cool projects by VIVINAUTS in the VIVIBOOM universe!',
  },
  projectDescOthers: {
    en: 'Check out the cool projects by fellow creators in the VIVIBOOM universe!',
    ja: 'VIVIBOOM ユニバースのクリエイター仲間によるクールなプロジェクトを探索してください!',
    et: 'Avastage VIVIBOOMi universumis kaasloojate lahedaid projekte!',
    lt: 'Naršykite puikius kitų kūrėjų projektus VIVIBOOM visatoje!',
    ph: 'Explore the fascinating projects crafted by other creators in the VIVIBOOM universe!',
    ch: '探索 VIVIBOOM 宇宙中其他创作者的精彩项目！',
  },
  Description: {
    en: 'Description',
    ja: '説明',
    et: 'Kirjeldus',
    lt: 'Apibūdinimas',
    ph: 'Description',
    ch: 'Description',
  },
  'Add Comment': {
    en: 'Add Comment',
    ja: 'コメントを追加',
    et: 'Lisa kommentaar',
    lt: 'Pridėti komentarą',
    ph: 'Add Comment',
    ch: 'Add Comment',
  },
  'Badges earned for this project': {
    en: 'Badges earned for this project',
    ja: 'このプロジェクトが獲得したバッジ',
    et: 'See projekt on saanud järgmised märgid',
    lt: 'Už šį projektą užtarnauti ženkliukai',
    ph: 'Badges earned for this project',
    ch: 'Badges earned for this project',
  },
  'You can earn these badges by participating in this project': {
    en: 'You can earn these badges by participating in this project',
    ja: 'このプロジェクトを参加するとバッジを獲得できます。',
    et: 'Võid teenida neid märke osaledes selles projektis',
    lt: 'Už šį projektą gali užsitarnauti šiuos ženkliukus',
    ph: 'You can earn these badges by participating in this project',
    ch: 'You can earn these badges by participating in this project',
  },
  'Other projects': {
    en: 'Other projects',
    ja: '他のプロジェクト',
    et: 'Muud projektid',
    lt: 'Kiti projektai',
    ph: 'Other projects',
    ch: 'Other projects',
  },
  'Edit Project': {
    en: 'Edit Project',
    ja: 'プロジェクトを変更',
    et: 'Muuda projekti',
    lt: 'Keisti projektą',
    ph: 'Edit Project',
    ch: 'Edit Project',
  },
  'Search Projects': {
    en: 'Search Projects',
    ja: 'プロジェクトを検索',
    et: 'Otsi projekte',
    lt: 'Projektų paieška',
    ph: 'Search Projects',
    ch: 'Search Projects',
  },
  'Add New Project': {
    en: 'Add New Project',
    ja: '新しいプロジェクトを追加',
    et: 'Lisa uusi projekti',
    lt: 'Pridėti naują projektą',
    ph: 'Add New Project',
    ch: 'Add New Project',
  },
  Categories: {
    en: 'Categories',
    ja: 'カテゴリ',
    et: 'Kategooriad',
    lt: 'Kategorijos',
    ph: 'Categories',
    ch: 'Categories',
  },
  'FILTER BY': {
    en: 'FILTER BY',
    ja: 'フィルター',
    et: 'Filtrid',
    lt: 'FILTRUOTI PAGAL',
    ph: 'FILTER BY',
    ch: 'FILTER BY',
  },
  'Newly Created': {
    en: 'Newly Created',
    ja: '新規プロジェクト',
    et: 'Värsked',
    lt: 'Naujai sukurti',
    ph: 'Newly Created',
    ch: 'Newly Created',
  },
  Recommended: {
    en: 'Recommended',
    ja: 'おすすめプロジェクト',
    et: 'Soovitatud',
    lt: 'Rekomenduojami',
    ph: 'Recommended',
    ch: 'Recommended',
  },
  'Work-in-Progress': {
    en: 'Work-in-Progress',
    ja: '製作中のプロジェクト',
    et: 'Pooleliolevad projektid',
    lt: 'Vykdomi ',
    ph: 'Work-in-Progress',
    ch: 'Work-in-Progress',
  },
  'Please refresh to view a new set of random projects!': {
    en: 'Please refresh to view a new set of random projects!',
    ja: '新しいプロジェクトを見るにはブラウザをリロードしてください',
    et: 'Värskenda, et näha uut projektide juhuvalikut.',
    lt: 'Atnaujink puslapį kad matytum naujus projektus!',
    ph: 'Please refresh to view a new set of random projects!',
    ch: 'Please refresh to view a new set of random projects!',
  },
  'Yay! Your project is posted!': {
    en: 'Yay! Your project is posted!',
    ja: 'やった！プロジェクトを公開しました！',
    et: 'Jee! Sinu projekt on avalikustatud.',
    lt: 'Valio, tavo projektas paviešintas.',
    ph: 'Yay! Your project is posted!',
    ch: 'Yay! Your project is posted!',
  },
  'Share your project with the VIVITA community!': {
    en: 'Share your project with the VIVITA community!',
    ja: 'VIVITAコミュニティーにプロジェクトをシェアしよう！',
    et: 'Jaga oma projekti VIVITA kogukonnaga.',
    lt: 'Pasidalink savo projektu su VIVITA bendruomene!',
    ph: 'Share your project with the VIVITA community!',
    ch: 'Share your project with the VIVITA community!',
  },
  'Showcase what you have created': {
    en: 'Showcase what you have created',
    ja: '作ったプロジェクトをみんなに見せよう！',
    et: 'Esitle oma loomingut',
    lt: 'Pasidalink savo kūryba',
    ph: 'Showcase what you have created',
    ch: 'Showcase what you have created',
  },
  'Post a Project': {
    en: 'Post a Project',
    ja: 'プロジェクトを公開',
    et: 'Avalda projekt',
    lt: 'Pasidalink savo projektu',
    ph: 'Post a Project',
    ch: 'Post a Project',
  },
  Saving: {
    en: 'Saving',
    ja: '保存中',
    et: 'Salvestab',
    lt: 'Išsaugojimas',
    ph: 'Saving',
    ch: 'Saving',
  },
  'images and files': {
    en: 'images and files',
    ja: '画像とファイル',
    et: 'pildid ja failid',
    lt: 'nuotraukos ir failai',
    ph: 'images and files',
    ch: 'images and files',
  },
  'Yay! Your project update is posted!': {
    en: 'Yay! Your project update is posted!',
    ja: 'やった！プロジェクトを公開しました！',
    et: 'Jei! Sinu projektiuuendus on avaldatud.',
    lt: 'Valio, tavo projektas paviešintas.',
    ph: 'Yay! Your project update is posted!',
    ch: 'Yay! Your project update is posted!',
  },
  'Section Deleted!': {
    en: 'Section Deleted!',
    ja: 'セクションを削除した',
    et: 'Jagu kustutatud!',
    lt: 'Dalis ištrinta',
    ph: 'Section Deleted!',
    ch: 'Section Deleted!',
  },
  'Made some progress to your project?': {
    en: 'Made some progress to your project?',
    ja: 'プロジェクトを進みましたか？',
    et: 'Kuidas sinu projekt edeneb?',
    lt: 'Ar atnaujinai savo projektą?',
    ph: 'Made some progress to your project?',
    ch: 'Made some progress to your project?',
  },
  'Add Project Update': {
    en: 'Add Project Update',
    ja: 'プロジェクトアップデートを追加',
    et: 'Lisa projektiuuendus',
    lt: 'Pridėti projekto atnaujinimą',
    ph: 'Add Project Update',
    ch: 'Add Project Update',
  },
  'Created By': {
    en: 'Created By',
    ja: '製作者',
    et: 'Autor',
    lt: 'Projektą sukūrė',
    ph: 'Created By',
    ch: 'Created By',
  },
  'Inspired By': {
    en: 'Inspired By',
    ja: '参考元',
    et: 'Inspireeritud järgmistest',
    lt: 'Projektą įkvėpė',
    ph: 'Inspired By',
    ch: 'Inspired By',
  },
  'Badges Awarded': {
    en: 'Badges Awarded',
    ja: '獲得したバッジ',
    et: 'Saadud märgid',
    lt: 'Užtarnauti ženkliukai',
    ph: 'Badges Awarded',
    ch: 'Badges Awarded',
  },
  'Got an update on this project? Share it here!': {
    en: 'Got an update on this project? Share it here!',
    ja: 'プロジェクトにアップデートがありますか？シェアしてください！',
    et: 'Kuidas sinu projekt edeneb? Jaga uuendusi siin!',
    lt: 'Atnaujinai projektą? Pasidalink čia!',
    ph: 'Got an update on this project? Share it here!',
    ch: 'Got an update on this project? Share it here!',
  },
  'Were you inspired? Hit the like button to let the creators know!': {
    en: 'Were you inspired? Hit the like button to let the creators know!',
    ja: '素晴らしいプロジェクトだと思うなら、「いいね」ボタンを押して製作者を励まそう！',
    et: 'Kas see inspireeris sind? Kliki "Meeldib" nuppu, et projekti autor sellest ka teada saaks',
    lt: 'Gavai įkvėpimo? Paspausk Patinka, kad kūrėjas tai žinotų!',
    ph: 'Were you inspired? Hit the like button to let the creators know!',
    ch: 'Were you inspired? Hit the like button to let the creators know!',
  },
  Chat: {
    en: 'Chat',
    ja: 'チャット',
    et: 'Vestlus',
    lt: 'Kalbėtis',
    ph: 'Chat',
    ch: 'Chat',
  },
  'Go to chat': {
    en: 'Go to chat',
    ja: 'チャットへ',
    et: 'Mine vestlusaknasse',
    lt: 'Eiti į pokalbius',
    ph: 'Go to chat',
    ch: 'Go to chat',
  },
  'Type something here to ask the creators more about the project!': {
    en: 'Type something here to ask the creators more about the project!',
    ja: 'ここで私にメッセージをください',
    et: 'Jäta oma sõnum siia!',
    lt: 'Parašyk kažką čia, kad išsiųstum asmeninę žinutę',
    ph: 'Type something here to ask the creators more about the project!',
    ch: 'Type something here to ask the creators more about the project!',
  },
  'Other Projects': {
    en: 'Other Projects',
    ja: 'その他のプロジェクト',
    et: 'Muud projektid',
    lt: 'Kiti projektai',
    ph: 'Other Projects',
    ch: 'Other Projects',
  },
  'Only 10 images can be added': {
    en: 'Only 10 images can be added',
    ja: 'Only 10 images can be added',
    et: 'Only 10 images can be added',
    lt: 'Only 10 images can be added',
    ph: 'Only 10 images can be added',
    ch: 'Only 10 images can be added',
  },
  'Only 5 videos can be added': {
    en: 'Only 5 videos can be added',
    ja: 'Only 5 videos can be added',
    et: 'Only 5 videos can be added',
    lt: 'Only 5 videos can be added',
    ph: 'Only 5 videos can be added',
    ch: 'Only 5 videos can be added',
  },
  authors: {
    en: '{{name1}} <2>and</2> {{name2}}',
    ja: '{{name1}} <2>and</2> {{name2}}',
    et: '{{name1}} <2>and</2> {{name2}}',
    lt: '{{name1}} <2>and</2> {{name2}}',
    ph: '{{name1}} <2>and</2> {{name2}}',
    ch: '{{name1}} <2>and</2> {{name2}}',
  },
  Authors: {
    en: 'Authors',
    ja: 'Authors',
    et: 'Authors',
    lt: 'Authors',
    ph: 'Authors',
    ch: 'Authors',
  },
  and: {
    en: 'and',
    ja: 'and',
    et: 'and',
    lt: 'and',
    ph: 'and',
    ch: 'and',
  },
  collaboration: {
    en: 'Project Collaborators',
    ja: 'Project Collaborators',
    et: 'Project Collaborators',
    lt: 'Project Collaborators',
    ph: 'Project Collaborators',
    ch: 'Project Collaborators',
  },
  authorLimit: {
    en: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
    ja: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
    et: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
    lt: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
    ph: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
    ch: 'Add your friends or mentors as collaborators of your project. Max {{count}} collaborators',
  },
  'Add Collaborator': {
    en: 'Add Collaborator',
    ja: 'Add Collaborator',
    et: 'Add Collaborator',
    lt: 'Add Collaborator',
    ph: 'Add Collaborator',
    ch: 'Add Collaborator',
  },
  'New Collaborator': {
    en: 'New Collaborator',
    ja: 'New Collaborator',
    et: 'New Collaborator',
    lt: 'New Collaborator',
    ph: 'New Collaborator',
    ch: 'New Collaborator',
  },
  'Edit Collaborator': {
    en: 'Edit Collaborator',
    ja: 'Edit Collaborator',
    et: 'Edit Collaborator',
    lt: 'Edit Collaborator',
    ph: 'Edit Collaborator',
    ch: 'Edit Collaborator',
  },
  Role: {
    en: 'Role',
    ja: 'Role',
    et: 'Role',
    lt: 'Role',
    ph: 'Role',
    ch: 'Role',
  },
  selectRole: {
    en: 'Select Role',
    ja: 'Select Role',
    et: 'Select Role',
    lt: 'Select Role',
    ph: 'Select Role',
    ch: 'Select Role',
  },
  Author: {
    en: 'Author',
    ja: 'Author',
    et: 'Author',
    lt: 'Author',
    ph: 'Author',
    ch: 'Author',
  },
  Confirm: {
    en: 'Confirm',
    ja: 'Confirm',
    et: 'Confirm',
    lt: 'Confirm',
    ph: 'Confirm',
    ch: 'Confirm',
  },
  Owner: {
    en: 'Owner',
    ja: 'Owner',
    et: 'Owner',
    lt: 'Owner',
    ph: 'Owner',
    ch: 'Owner',
  },
  'Only 10 collaborators can be added': {
    en: 'Only 10 collaborators can be added',
    ja: 'Only 10 collaborators can be added',
    et: 'Only 10 collaborators can be added',
    lt: 'Only 10 collaborators can be added',
    ph: 'Only 10 collaborators can be added',
    ch: 'Only 10 collaborators can be added',
  },
  'Please add a role for this collaborator!': {
    en: 'Please add a role for this collaborator!',
    ja: 'Please add a role for this collaborator!',
    et: 'Please add a role for this collaborator!',
    lt: 'Please add a role for this collaborator!',
    ph: 'Please add a role for this collaborator!',
    ch: 'Please add a role for this collaborator!',
  },
  'Please select a collaborator!': {
    en: 'Please select a collaborator!',
    ja: 'Please select a collaborator!',
    et: 'Please select a collaborator!',
    lt: 'Please select a collaborator!',
    ph: 'Please select a collaborator!',
    ch: 'Please select a collaborator!',
  },
  'Are you sure you want to delete this collaborator?': {
    en: 'Are you sure you want to delete this collaborator?',
    ja: 'Are you sure you want to delete this collaborator?',
    et: 'Are you sure you want to delete this collaborator?',
    lt: 'Are you sure you want to delete this collaborator?',
    ph: 'Are you sure you want to delete this collaborator?',
    ch: 'Are you sure you want to delete this collaborator?',
  },
  'Submit your challenge and earn badges here!': {
    en: 'Submit your challenge and earn badges here!',
    ja: 'Submit your challenge and earn badges here!',
    et: 'Submit your challenge and earn badges here!',
    lt: 'Submit your challenge and earn badges here!',
    ph: 'Submit your challenge and earn badges here!',
    ch: 'Submit your challenge and earn badges here!',
  },
  'Select the relevant challenges and badges!': {
    en: 'Select the relevant challenges and badges!',
    ja: 'Select the relevant challenges and badges!',
    et: 'Select the relevant challenges and badges!',
    lt: 'Select the relevant challenges and badges!',
    ph: 'Select the relevant challenges and badges!',
    ch: 'Select the relevant challenges and badges!',
  },
  'Select Badge': {
    en: 'Select Badge',
    ja: 'Select Badge',
    et: 'Select Badge',
    lt: 'Select Badge',
    ph: 'Select Badge',
    ch: 'Select Badge',
  },
  'Select Challenge': {
    en: 'Select Challenge',
    ja: 'Select Challenge',
    et: 'Select Challenge',
    lt: 'Select Challenge',
    ph: 'Select Challenge',
    ch: 'Select Challenge',
  },
  'Oops! Seems like there are no badges here': {
    en: 'Oops! Seems like there are no badges here',
    ja: 'Oops! Seems like there are no badges here',
    et: 'Oops! Seems like there are no badges here',
    lt: 'Oops! Seems like there are no badges here',
    ph: 'Oops! Seems like there are no badges here',
    ch: 'Oops! Seems like there are no badges here',
  },
  'Oops! Seems like there are no challenges here': {
    en: 'Oops! Seems like there are no challenges here',
    ja: 'Oops! Seems like there are no challenges here',
    et: 'Oops! Seems like there are no challenges here',
    lt: 'Oops! Seems like there are no challenges here',
    ph: 'Oops! Seems like there are no challenges here',
    ch: 'Oops! Seems like there are no challenges here',
  },
  'Search Challenges': {
    en: 'Search Challenges',
    ja: 'Search Challenges',
    et: 'Search Challenges',
    lt: 'Search Challenges',
    ph: 'Search Challenges',
    ch: 'Search Challenges',
  },
};
